import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKill = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m7.05 13.406 3.534 3.536-1.413 1.414 1.415 1.415-1.414 1.414-2.475-2.475-2.829 2.829-1.414-1.414 2.829-2.83-2.475-2.474 1.414-1.414 1.414 1.413 1.413-1.414zm-4.05-10.406 3.546.003 11.817 11.818 1.415-1.414 1.414 1.414-2.474 2.475 2.828 2.829-1.414 1.414-2.829-2.829-2.475 2.475-1.414-1.414 1.414-1.415-11.825-11.825zm14.457 0 3.543.003.002 3.523-4.053 4.052-3.536-3.535z",
		fill: "transparent",
		stroke: "#93abc9",
		strokeWidth: 1
	})
});
export default SvgKill;
